module.exports = __webpack_public_path__ + "static/media/socketIcon.dd1c001e.svg";